import { render, staticRenderFns } from "./video-duration.vue?vue&type=template&id=e4f0bc34&"
import script from "./video-duration.vue?vue&type=script&lang=js&"
export * from "./video-duration.vue?vue&type=script&lang=js&"
import style0 from "./video-duration.vue?vue&type=style&index=0&id=e4f0bc34&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports